import DataProvider from '../DataProvider.js'

const validateEmail = async (email) => {
    try {
        //this will return 0 & true if there are no users
        const isValid = await DataProvider.getList('users', { pagination: {}, sort: { field: 'email', order: 'ASC' }, filter: { EmailValidate: email } })
        if (isValid.data.result) {
            return
        } else {
            return "Error: A User with that email already exists"
        }
    } catch (err) {
        console.log(err)
    }
};

export default validateEmail